<template>
	<div class="contentPage">

		<main-table-all-back
				v-if="logbooksmodList"
				:flag="flag"
				text-create="Create actions"
				page-title="Logbooks"
				labelSearch="Search phone"
				:headers="headers"
				:settings="getSettings"
				:filtersList="logbooksmodFilters"
				:list="logbooksmodList"
				:defaultOrder="logbooksmodOrder"
				:defaultSort="logbooksmodSort"
				:defaultFilter="defaultFilter"
				:totals="logbooksmodTotals"
				:total-pages="logbooksmodTotal"
				:limit-pages="logbooksmodLimit"
				:pages="[ 12, 15, 20, 50, 100, 200, 500, 'All' ]"
				:uniqId="uniqId"
				@updateSettings="onSettingsOpen"
				@updateEvent="onEvent"
				@updateClickButton="onClickButton"
				@updateModEvent="onModEvent"
				@updateList="onList"
				@updateEdit="onEdit"
				@updateRefreshFilters="onUpdateFilters($event || activeTableFilters || defaultFilter)"
				@updateExport="onExport"
				is-export
				:is-export-permissions="isExport()"
				is-create
				is-settings
				:externalRefreshKey="externalRefreshKey"
				:externalResetKey="externalResetKey"
				:externalResetMode="externalResetMode"
		>
			<template slot="customButtons">

<!--				<v-btn @click="externalRefresh()">-->
<!--					<span class="btnText">Update list</span>-->
<!--				</v-btn>-->

<!--				<v-btn @click="externalReset('default')">-->
<!--					<span class="btnText">Reset list default</span>-->
<!--				</v-btn>-->
<!--				<v-btn @click="externalReset('empty')">-->
<!--					<span class="btnText">Reset list empty</span>-->
<!--				</v-btn>-->

				<exception-b-t-n @updateException="onExceptionMod" :exception-count="exceptionCount"/>
			</template>

		</main-table-all-back>

		<table-settings
				v-if="isTableSettingsDrawer"
				@updateSettingsSave="onSettingsSave('safety')"
				@updateSettingsCancel="onSettingsCancel"
				@updateSettingsClose="onSettingsClose"
				@updateSettingsAll="onSettingsAll"
				:settings="getSettings"
		></table-settings>

		<create-actions
				v-if="isCreateActions"
				@updateException="onExceptionMod"
				@updateCloseDialogCreateActions="onCloseCreateActions"
				@updateList="onUpdateList"
				:exception-count="exceptionCount"
				:customer-list="safetyCreateCustomers"
				:request-list="safetyCreateRequest"
				:active-item="activeItem"
				:active-line="activeLine"
		/>

		<exception
				ref="exceptionModal"
				v-if="isException"
				@updateCloseDialogExceptions="onCloseExceptions"
				@updateCloseDialog="onCloseException('isException')"
				@updateEdit="onExceptionEdit"
				@updateAdd="onAddException(getTitle.EXCEPTION)"
		></exception>

		<add-exception
				v-if="isAddException"
				title="Add new exception"
				@updateCloseDialog="onCloseException('isAddException')"
				@updateExceptionSave="onExceptionSave($event, addExceptionTitle)"
		></add-exception>

		<user-list-actions
				v-if="isUserListActions"
				:items="getDriverActions"
				@updateCloseDialog="updateCloseDialogUserListActions"
				@updateClickButton="onClickButtonUserListActions"
		></user-list-actions>

		<dialog-remove
				v-if="isDialogRemove"
				:titleRemove="titleRemove"
				:textRemove="textRemove"
				@updateRemove="onRemove"
				@updateCloseRemove="onCloseRemove"
		></dialog-remove>

<!--		<dialog-info-->
<!--			v-if="isDialogInfo"-->
<!--			:title="titleDialogInfo"-->
<!--			:text="lineDialogInfo"-->
<!--			@updateApply="onDialogInfoApply"-->
<!--			@updateClose="onDialogInfoApply"-->
<!--		/>-->

		<dialog-slot
				v-if="isDialogInfo"
				:title="titleDialogInfo"
				@updateClose="onDialogInfoApply"
				@updateSave="onDialogInfoApply"
				is-cancel-hide
				apply-text="Save"
		>
			<input-cell
					:item="itemDialogInfo"
					:line="lineDialogInfo"
					@updateModEvent="onCustomerInformation($event)"
			></input-cell>
		</dialog-slot>

		<customer-form
				v-if="isCustomerForm"
				:id="idCustomer"
				@updateClose="onCloseCustomerForm"
				@updateSave="onSaveCustomerForm"
		></customer-form>

		<add-comment
				v-if="isAddComment"
				title="Add comment"
				@updateCloseDialog="onCloseException('isAddComment')"
				@updateSaveComment="onSaveComment($event)"
		/>
<!--		<edit-exception-->
<!--				v-if="isEditException"-->
<!--				:edit-exception-status="status"-->
<!--				@updateCloseDialog="onCloseException('isEditException')"-->
<!--				@updateAddComment="onAddComment()"-->
<!--				@updateViewFile="onViewFile($event)"-->
<!--		></edit-exception>-->
		<!--	  @updateAddComment="onAdd(getTitle.COMMENT)"-->
		<edit-exception
				v-if="isEditException"
				:edit-exception-status="status"
				@updateCloseDialog="onCloseException('isEditException')"
				@updateAddComment="onAddComment()"
				@updateViewFile="onViewFile($event)"
				@updateRefreshExceptions="onRefreshExceptions"
		></edit-exception>
		<remove-block
				v-if="isRemove"
				@updateRemoveItem="onRemoveItem"
				@updateRemoveClose="onRemoveClose"
				:preloader="getPreloader"
		></remove-block>

		<eld-popup v-if="eldList" :eldList="eldList" @updateCloseDialog="onCloseDialogEld"></eld-popup>

		<!--//////////////   new   //////////////////-->

		<preloader v-if="isPreloader"></preloader>

		<preview-doc v-if="link" @clear-link="clearLink" :link-doc="link" :file-name="link"/>
	</div>
</template>

<script>

import { mapActions, mapGetters } from "vuex";

import MainTableAllBack from "@/shared/MainTableAllBack/MainTableAllBack";

import settingsMixins from "@/mixins/settingsMixins";
import removeMixins from "@/mixins/removeMixins";

import { PERMISSIONS, PAGE } from "@/constants/constants";
import { getPermissionsMod } from "@/helper/getPermissionsMod";
import ExceptionBTN from "@/pages/Safety/LogbooksList/ExceptionBTN/ExceptionBTN.vue";
import UserListActions from "@/pages/Safety/LogbooksList/UserListActions/UserListActions.vue";
import getUniqId from "@/helper/getUniqId";
import CreateActions from "@/pages/Safety/LogbooksList/CreateActions/CreateActions.vue";
import Exception from "@/pages/Safety/LogbooksList/Exception/Exception.vue";
import { TITLE } from "@/pages/Safety/LogbooksList/constants";
import AddException from "@/components/Safety/Logbooks/AddException/AddException.vue";
import { getAppUrl } from "@/services";
import DialogRemove from "@/shared/DialogRemove/DialogRemove.vue";
import AddComment from "@/components/Safety/Logbooks/AddComment/AddComment.vue";
import Preloader from "@/shared/Preload/Preload.vue";
import PreviewDoc from "@/modules/invoices/preview.vue";
// import DialogInfo from "@/shared/DialogInfo/DialogInfo.vue";
import { saveSafetyInformation } from "@/services/safetyService";
import DialogSlot from "@/shared/DialogSlot/DialogSlot.vue";
import InputCell from "@/shared/MainTable/RowTr/InputCell/InputCell.vue";

// Старе
// async components
const CustomerForm = () => import("@/components/Maintenance/Customer/CustomerForm/CustomerForm");
const EldPopup = () => import("@/components/Safety/Logbooks/EldPopup/EldPopup");
const EditException = () => import("@/components/Safety/Logbooks/EditException/EditException");

const RemoveBlock = () => import("@/shared/RemoveBlock/RemoveBlock");

export default {
	name: "LogbooksMod",
	mixins: [ settingsMixins, removeMixins ],
	components: {
		InputCell,
		DialogSlot,
		// DialogInfo,
		AddComment,
		DialogRemove,
		AddException,
		Exception,
		CreateActions,
		UserListActions,
		ExceptionBTN,
		MainTableAllBack,

		// Старе

		RemoveBlock,
		CustomerForm,
		EditException,
		EldPopup,
		Preloader,
		PreviewDoc,
	},
	computed: {
		...mapGetters([
			"logbooksmodList",
			"logbooksmodFilters",
			"logbooksmodTotals",
			"permissions",
			"role",
			"logbooksmodOrder",
			"logbooksmodLimit",
			"logbooksmodSort",
			"logbooksmodTotal",
			"previewLink",
			"company_id",

			"permissionsDefault",
			"createCustomers",
			"createRequest",

			"safetyCreateCustomers",
			"safetyCreateRequest",

			// Старое

			"permissions",
			"createLogbooksReports",
			"driverActionsLogbooks",

			"getPreloader",
			"eldList",
			"exceptionCount",
			"safetyCreateCustomers",
			"safetyCreateRequest",
		]),

		getTitle() {
			return TITLE;
		},

		getDriverActions() {
			return (
				this.driverActionsLogbooks &&
					this.driverActionsLogbooks.list.filter((action) => action.status !== 0)
			);
		},
	},
	data: () => ({
		flag: PAGE.LOGBOOKSMOD,

		isLogbooksModForm: false,
		defaultFilter: {
			filter_status_serves: [ 1 ],
		},
		activeTableFilters: null,
		employeeId: null,
		activeItem: null,
		activeLine: null,
		isCreateActions: false,
		isUserListActions: false,

		addExceptionTitle: TITLE.EXCEPTION,
		isException: false,
		isAddException: false,
		isAddComment: false,
		isEditException: false,

		externalRefreshKey: null, // Обновление списка с фильтрами
		externalResetKey: null, // Сброс фильтров
		externalResetMode: 'default', // Тип сброса фильтров ('default' сброс до дефолтніх фильтров) | ('empty' спрос всех фильтров)

		isDialogRemove: false,
		titleRemove: null,
		textRemove: null,
		typeRemove: null,

		isDialogInfo: false,
		titleDialogInfo: null,
		itemDialogInfo: { value: 'information' },
		lineDialogInfo: null,

		// Старе
		isPopupCreateLogbooksReports: false,
		// isDialog: false,
		status: false,
		// dataActions: null,
		// dataSort: {},

		isFilterLoad: false,
		customersData: [],
		customersSelect: [],
		selected: [],
		indeterminate: false,
		checkAll: false,
		snackbarSend: false,
		valid: true,
		lazy: false,
		link: null,

		isPreloader: false,
		isCustomerForm: false,
		idCustomer: null,

		isInputLoading: false,

	}),
	methods: {
		...mapActions([
			'getEldList',
			'getLogbooksMod',
			'getLogbooksModFilters',
			'getTotalLogbooksMod',
			'getCreateAction',

			// Старіе
			"getLogbooksList",
			"getCreateLogbooksReports",
			"setCreateLogbooksReports",
			"getFiltersLogbooks",
			"getTotalLogbooks",
			"onLogbooksDriverActions",
			"deleteLogbooksDriverAction",
			"onExportLink",
			"onCreateSafetyReports",
			"onSentSafetyReports",
			"setAlert",
			"getExceptionCount",
			"onException",
			"onRemoveException",
			"getExceptionItem",
			"onExceptionActions",
			"onClearEld",
			"getSafetyCreateCustomers",

		]),

		onRefreshExceptions() {
			if (this.$refs.exceptionModal) {
				this.$refs.exceptionModal.refreshTables();
			}
		},

		updateCloseDialogUserListActions() {
			this.isUserListActions = false;
		},

		async onCreateActions() {

			await this.getSafetyCreateCustomers();
			this.isCreateActions = true;
		},

		onClickButtonUserListActions(args) {
			const { key, item } = args;
			this.activeItem = item;

			const { file } = item;

			if (key === "view") this.onPreview(getAppUrl + file);

			if (key === "delete") {
				const { notes, employee } = item;
				const title = '🗑️ Confirm Action Deletion';
				const text = `⚠️ Are you sure you want to delete action <b>${ notes }</b> created by 👤 <b>${ employee }</b>?`;
				this.onRemoveDialog({ title, text, type: 1, });
			}
			if (key === "edit") {
				this.onCreateActions();
			}
		},

		onRemoveDialog(args) {
			const { title, text, type } = args;
			this.titleRemove = title;
			this.textRemove = text;
			this.typeRemove = type;
			this.isDialogRemove = true;
		},

		onCloseRemove() {
			this.isDialogRemove = false;
			this.typeRemove = null;
		},

		async onRemove() {

			if (this.typeRemove === 1) {
				this.onCloseRemove();
				this.$store.commit("logbooksDeleteAction", this.activeItem);
				await this.deleteLogbooksDriverAction(this.activeItem);
				this.externalRefresh();

			} else {
				this.isPreloader = true;
				this.onCloseRemove();

				await this.onRemoveException(this.activeItem.id);
				this.isPreloader = false;
			}
			this.activeItem = null;
		},

		async onActions() {
			const { driver_id, date, employees, frozen, status_serves } = this.activeLine;
			const values = {
				id: driver_id,
				date,
				employees,
				frozen: !!frozen,
				safety: !!status_serves,
			};

			await this.onLogbooksDriverActions(values);
			this.isUserListActions = true;
			this.dataActions = values;
		},

		onUpdateList(edit) {
			if (edit) {
				this.onActions();
			} else {
				this.externalRefresh();
			}
		},

		onCloseCreateActions() {
			this.isCreateActions = false;
			this.activeItem = null;
		},
		onExceptionMod() {
			this.isException = true;
		},
		onCloseExceptions() {
			this.isException = false;
		},

		async onEvent(flag) {

			console.log('%c [onEvent  flag  ] ', 'color:#bada55', typeof flag, flag );

			if (flag === 'create') {
				this.onCreateActions();
				// await this.getCreateAction();
				// this.isCreateActions = true;
			}
		},

		isExport() {
			const list = this.permissionsDefault;
			const path = [ PERMISSIONS.SAFETY, PERMISSIONS.LOGBOOKS, PERMISSIONS.EXPORT ];
			return getPermissionsMod({ list, path });
		},

		async onExport(values) {
			await this.onExportLink({ values, requestKey: 'safety' });
		},
		
		onCloseDialog(isRefresh) {
			this.isLogbooksModForm = false;
			if (isRefresh) {
				this.onUpdateFilters(this.defaultFilter);
			}
		},
		onCloseDialogEld() {
			this.onClearEld();
		},

		async onUpdateFilters(filters = {}, isWithoutFilters) {

			if (!filters || typeof filters !== 'object') {
				filters = {};
			}

			await this.getLogbooksMod(filters);
			if (!isWithoutFilters) await this.getLogbooksModFilters(filters);
			await this.getTotalLogbooksMod(filters);
		},

		async onList(values) {
			const { value, flag } = values;
			// сохраняем выбранные фильтры отдельно
			this.activeTableFilters = value;

			switch (flag) {
				case "sorting":
					await this.getLogbooksMod(value);
					break;
				case "page":
					await this.onUpdateFilters(value, true);
					break;
				default:
					await this.onUpdateFilters(value);
			}
		},

		async onClickButton({ key, item }) {
			this.activeLine = item;
			if (key === "actions") {
				this.onActions();
			}
		},
		async onModEvent(args) {
			console.log('%c [  args  ] ', 'color:#bada55', typeof args, args );
			const { line, flag, value } = args;
			if (flag === 'link') {
				this.isCustomerForm = true;
				this.idCustomer = line.customer_id;
			}
			if (flag === 'info') {
				const title = `Safety Service Info — <b>${ line.customer_name }</b>`;
				this.initDialogInfo({ title, line });
			}
			if (flag === 'count') {
				await this.getEldList(line['customer_id']);
			}
			if (flag === 'driver_notes') {

				this.isInputLoading = true;

				try {
					const data = await saveSafetyInformation( `/safety/driver/${ line.driver_id }`, { notes: value } );

					this.$emit("saved", data);

					this.$store.dispatch("setAlert", {
						type: "success",
						message: "Safety information saved successfully"
					});
				} catch (error) {
					console.error(error);

					this.$store.dispatch("setAlert", {
						type: "error",
						message: "Failed to save safety information"
					});
				} finally {
					this.isInputLoading = false;
				}
			}
		},
		async onCustomerInformation(args) {
			console.log('%c [  args  ] ', 'color:#bada55', typeof args, args );
			const { value } = args;
			this.isInputLoading = true;

			try {
				const data = await saveSafetyInformation( `/safety/customer/${ this.lineDialogInfo.customer_id }`, { information: value } );

				this.$emit("saved", data);

				this.$store.dispatch("setAlert", {
					type: "success",
					message: "Safety information saved successfully"
				});
				this.externalRefresh();
			} catch (error) {
				console.error(error);

				this.$store.dispatch("setAlert", {
					type: "error",
					message: "Failed to save safety information"
				});
			} finally {
				this.isInputLoading = false;
			}
		},
		initDialogInfo(args) {
			const { title, line } = args;
			this.titleDialogInfo = title;
			this.lineDialogInfo = line;
			this.isDialogInfo = true;
		},
		onDialogInfoApply() {
			this.isDialogInfo = false;
		},

		onSaveCustomerForm() {
			this.onCloseCustomerForm();
			this.externalRefresh();
		},
		onCloseCustomerForm() {
			this.isCustomerForm = false;
			this.idCustomer = null;
		},

		onEdit(payload) {
			console.log('%c [ onEdit payload  ] ', 'color:#bada55', typeof payload, payload );
		},

		async onExceptionEdit({ key, item }) {
			this.activeItem = item;
			
			if (key === "view") {
				this.onPreview(getAppUrl + item.file);
			}

			if (key === "edit") {
				await this.getExceptionItem(item.id);
				this.status = !item.status;
				this.isEditException = true;
			}

			if (key === "delete") {
				if (!item.action_delete) return this.setAlert({ type: "error", message: "You do not have delete access" });
				// this.getRemoveItem(item.id);

				const title = '🗑️ Confirm Action Deletion';
				const text = `⚠️ Are you sure you want to delete this exception?`;
				this.onRemoveDialog({ title, text, type: 2 });
			}
		},
		async onExceptionSave(values, key) {
			if (TITLE.EXCEPTION === key) {
				await this.onException(values);
			}

			this.isAddException = false;
		},
		onAddException(title) {
			this.isAddException = true;
			this.addExceptionTitle = title;
		},

		onCloseException(key) {
			this[key] = false;
		},

		externalRefresh() {
			// обновить таблицу, сохранив текущие фильтры
			this.externalRefreshKey = getUniqId();
		},
		externalReset(mode) {
			// 'default' | 'empty' (default до дефолтних | empty усі фільтра)
			this.externalResetMode = mode;
			this.externalResetKey = getUniqId();
		},

		// Старое

		async onRemoveItem() {
			await this.onRemoveException(this.removeId);
			this.isRemove = false;
		},
		onViewFile(item) {
			this.onPreview(getAppUrl + item.file);
		},
		
		onAddComment() {
			this.isAddComment = true;
		},
		onSaveComment(values) {
			this.isAddComment = false;
			this.onExceptionActions(values);
		},

		onCheckOrder(id, line) {
			const idx = this.selected.findIndex((e) => e.reports_id === id);
			if (idx === -1) {
				this.selected.push(line);
			} else {
				this.selected.splice(idx, 1);
			}
			if (!this.selected.length) {
				this.indeterminate = false;
				this.checkAll = false;
			}
			if (
				this.selected.length &&
					this.selected.length !== this.createLogbooksReports.length
			) {
				this.indeterminate = true;
			}
			if (this.selected.length === this.createLogbooksReports.length) {
				this.indeterminate = false;
				this.checkAll = true;
			}
		},
		onCheckOrders(value) {
			if (value) {
				this.selected = this.createLogbooksReports.map((body) => body);
			} else {
				this.selected = [];
				this.indeterminate = false;
			}
			this.checkAll = value;
			this.createLogbooksReports.forEach((item) => (item.isCheck = value));
		},

		onPreview(file) {
			this.link = file;
		},
		clearLink() {
			this.link = null;
			this.activeItem = null;
		},

	},
	async mounted() {

		await this.onUpdateFilters(this.defaultFilter);
		await this.getExceptionCount();
	}
};
</script>
